<template>
    <div :class="`col-md-${field.size}`">
        <TextInput v-if="field.type === 'text'" :fieldId="fieldId" />
        <DropDown v-else-if="field.type === 'select'" :fieldId="fieldId" />
        <Box v-else :fieldId="fieldId" />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import Box from './Box.vue'
    import DropDown from './DropDown.vue'
    import TextInput from './TextInput.vue'

    export default {
        name: 'Column',
        components: {
            Box,
            DropDown,
            TextInput,
        },
        props: [
            'fieldId',
        ],
        computed: {
            ...mapState([
                'editorsEnabled',
            ]),
            field() {
                const { state } = this.$store

                return state.fields[this.fieldId]
            },
        },
        methods: {},
    }
</script>

<style scoped>
   .show-options .editor {
      border: 2px solid #FFFFFF;
      transition: border-color 150ms;
   }
   .show-options .pg-options:hover ~ .editor,
   .show-options .editor:hover {
      border-color: #C0C0C0;
   }
</style>
